export const ANALYTICS_AFFILIATIONS = {
    booking: 'Booking',
    checkIn: 'Checkin',
    flightItinerary: 'FlightItinerary',
    manageBooking: 'ManageBooking'
}
